import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _SOAP_COMMENT_FORMAT, _SOAP_KINDS;

import { ActionButtonTypes, MemoCategoryKey, RoleType, SOAP_KIND, SoapCommentsKey, SoapCommentsOldKey, SoapType, SurveyType } from '../types';
import { summarizeQuestions } from './summarizeQuestions';
export var SOAP_COMMENT_FORMAT = (_SOAP_COMMENT_FORMAT = {}, _defineProperty(_SOAP_COMMENT_FORMAT, SoapCommentsKey.dr_comments, {
  oldKey: SoapCommentsOldKey.dr_comment,
  newKey: SoapCommentsKey.dr_comments,
  role: RoleType.CLINIC_DOCTOR_ROLE,
  kind: SoapCommentsKey.dr_comments,
  text: '醫師紀錄',
  i18n: 'common:tab.doctorComment'
}), _defineProperty(_SOAP_COMMENT_FORMAT, SoapCommentsKey.pre_rd_comments, {
  oldKey: SoapCommentsOldKey.pre_rd_comment,
  newKey: SoapCommentsKey.pre_rd_comments,
  role: RoleType.CLINIC_DIETICIAN_ROLE,
  kind: SoapCommentsKey.pre_rd_comments,
  text: '諮詢紀錄',
  textConsult: '分析紀錄',
  i18n: 'common:tab.pre_rd_comment',
  i18nConsult: 'common:normal.analysis_records'
}), _defineProperty(_SOAP_COMMENT_FORMAT, SoapCommentsKey.post_rd_comments, {
  oldKey: SoapCommentsOldKey.post_rd_comment,
  newKey: SoapCommentsKey.post_rd_comments,
  role: RoleType.CLINIC_DIETICIAN_ROLE,
  kind: SoapCommentsKey.post_rd_comments,
  text: '跟診紀錄',
  i18n: 'common:tab.post_rd_comments'
}), _defineProperty(_SOAP_COMMENT_FORMAT, SoapCommentsKey.pharmacist_comments, {
  oldKey: SoapCommentsOldKey.pharmacist_comment,
  newKey: SoapCommentsKey.pharmacist_comments,
  role: RoleType.CLINIC_PHARMACIST_ROLE,
  kind: SoapCommentsKey.pharmacist_comments,
  text: '藥師紀錄',
  i18n: 'common:tab.pharmacistComment'
}), _defineProperty(_SOAP_COMMENT_FORMAT, SoapCommentsKey.nurse_comments, {
  oldKey: SoapCommentsOldKey.nurse_comment,
  newKey: SoapCommentsKey.nurse_comments,
  role: RoleType.CLINIC_NURSE_ROLE,
  kind: SoapCommentsKey.nurse_comments,
  text: '護理師紀錄',
  i18n: 'common:tab.nurseComment'
}), _defineProperty(_SOAP_COMMENT_FORMAT, SoapCommentsKey.dietician_comments, {
  oldKey: SoapCommentsOldKey.dietician_comment,
  newKey: SoapCommentsKey.dietician_comments,
  role: RoleType.CLINIC_DIETICIAN_ROLE,
  kind: SoapCommentsKey.dietician_comments,
  text: '營養師紀錄',
  i18n: 'common:tab.dieticianComment'
}), _SOAP_COMMENT_FORMAT);
/** @deprecated use `SOAP_TYPES` instead, soap layout and behavior now determined by type. */

export var SOAP_KINDS = (_SOAP_KINDS = {}, _defineProperty(_SOAP_KINDS, SOAP_KIND.CLINIC, SOAP_KIND.CLINIC), _defineProperty(_SOAP_KINDS, SOAP_KIND.RD, SOAP_KIND.RD), _SOAP_KINDS);
export var getSoapProps = function getSoapProps() {
  var _ref;

  var can = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    return true;
  };
  return _ref = {}, _defineProperty(_ref, SoapType.flc_first, {
    key: SoapType.flc_first,
    surveys: [SurveyType.INIT_SURVEY_ID],
    showTopicGuide: false,
    text: '醫師門診',
    i18nKey: 'common:normal.doctorClinic',
    buttonType: ActionButtonTypes.Clinic,
    canCreate: can({
      type: 'data',
      subject: 'soap',
      action: 'create',
      property: 'flc_first'
    })
  }), _defineProperty(_ref, SoapType.NUTRITIONAL_SUPPLEMENT, {
    key: SoapType.NUTRITIONAL_SUPPLEMENT,
    surveys: [SurveyType.INIT_SURVEY_ID, SurveyType.HORMONES_SURVEY_ID, SurveyType.SUPPLEMENT_SURVEY_ID],
    showTopicGuide: false,
    text: '客製化保健品規劃',
    i18nKey: 'client:SOAP_TYPES.' + SoapType.NUTRITIONAL_SUPPLEMENT,
    buttonType: ActionButtonTypes.ConsultSub,
    memoCategory: MemoCategoryKey.personalized_supplement_consultation,
    summarizeQuestions: summarizeQuestions[SoapType.NUTRITIONAL_SUPPLEMENT],
    canCreate: true
  }), _defineProperty(_ref, SoapType.NUTRITIONAL_SUPPLEMENT_FOLLOW_UP, {
    key: SoapType.NUTRITIONAL_SUPPLEMENT_FOLLOW_UP,
    surveys: [SurveyType.SUPPLEMENT_RETURN_SURVEY_ID, SurveyType.SUPPLEMENT_FEEDBACK_SURVEY_ID],
    showTopicGuide: false,
    text: '保健一對一指導',
    i18nKey: 'client:SOAP_TYPES.' + SoapType.NUTRITIONAL_SUPPLEMENT_FOLLOW_UP,
    buttonType: ActionButtonTypes.ConsultSub,
    canCreate: true
  }), _defineProperty(_ref, SoapType.NUTRITIONAL_CONSULTATION, {
    key: SoapType.NUTRITIONAL_CONSULTATION,
    surveys: [SurveyType.INIT_SURVEY_ID, SurveyType.HORMONES_SURVEY_ID],
    showTopicGuide: true,
    text: '一對一分析',
    i18nKey: 'client:SOAP_TYPES.' + SoapType.NUTRITIONAL_CONSULTATION,
    buttonType: ActionButtonTypes.ConsultMain,
    memoCategory: MemoCategoryKey.one_on_one_consultation,
    summarizeQuestions: summarizeQuestions[SoapType.NUTRITIONAL_CONSULTATION],
    canCreate: true
  }), _defineProperty(_ref, SoapType.NUTRITIONAL_CONSULTATION_FOLLOW_UP, {
    key: SoapType.NUTRITIONAL_CONSULTATION_FOLLOW_UP,
    surveys: [],
    showTopicGuide: false,
    text: '飲食指導',
    i18nKey: 'client:SOAP_TYPES.' + SoapType.NUTRITIONAL_CONSULTATION_FOLLOW_UP,
    buttonType: ActionButtonTypes.ConsultMain,
    canCreate: true
  }), _defineProperty(_ref, SoapType.PSYCHOLOGICAL_COUNSELING, {
    key: SoapType.PSYCHOLOGICAL_COUNSELING,
    surveys: [],
    showTopicGuide: false,
    text: '心理師諮詢',
    i18nKey: 'client:SOAP_TYPES.' + SoapType.PSYCHOLOGICAL_COUNSELING,
    buttonType: ActionButtonTypes.Clinic,
    canCreate: can({
      type: 'data',
      subject: 'soap',
      action: 'create',
      property: 'psychological_counseling'
    })
  }), _defineProperty(_ref, SoapType.PSYCHOLOGICAL_COUNSELING_FOLLOW_UP, {
    key: SoapType.PSYCHOLOGICAL_COUNSELING_FOLLOW_UP,
    surveys: [],
    showTopicGuide: false,
    text: '心理師諮詢回診',
    i18nKey: 'client:SOAP_TYPES.' + SoapType.PSYCHOLOGICAL_COUNSELING_FOLLOW_UP,
    buttonType: ActionButtonTypes.Clinic,
    canCreate: true
  }), _defineProperty(_ref, SoapType.CLINIC_NUTRITIONAL_COUNSELING, {
    key: SoapType.CLINIC_NUTRITIONAL_COUNSELING,
    surveys: [],
    showTopicGuide: false,
    text: '營養師門診',
    i18nKey: 'client:SOAP_TYPES.' + SoapType.CLINIC_NUTRITIONAL_COUNSELING,
    buttonType: ActionButtonTypes.Clinic,
    canCreate: can({
      type: 'data',
      subject: 'soap',
      action: 'create',
      property: 'clinic_nutritional_counseling'
    })
  }), _ref;
};
export var SOAP_TYPES = getSoapProps();